import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./features/dashboard/Dashboard";
import BusinessCaseOverview from "./features/overview/BusinessCaseOverview";
import CreateBusinessCasePage from "./features/createbusinesscase/CreateBusinessCasePage";
import NotFound from "./components/customGenericComponents/NotFound/NotFound";

const AppRouter: React.FC = () => (
  <Routes>
    {/* Redirect root to dashboard */}
    <Route path="/" element={<Navigate to="/dashboard" replace />} />
    
    {/* Defined application routes */}
    <Route path="/dashboard" element={<Dashboard />} />
    <Route path="/business-case/:id" element={<BusinessCaseOverview />} />
    <Route path="/create-business-case" element={<CreateBusinessCasePage />} />
    
    {/* Catch-all route for 404 - MUST BE LAST */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRouter;